import type { JSX } from "react";

export function TrendDelta({ pct }: { pct: number }): JSX.Element {
  const up = pct >= 0;
  return <span className={`cc-delta ${up ? "cc-delta-up" : "cc-delta-down"}`}>{up ? "▲" : "▼"} {Math.abs(pct).toFixed(1)}%</span>;
}
